/* eslint-disable quotes */
/* eslint-disable semi */
import { storeGetters } from '@store/getters.constants';
const getters = {
  [storeGetters.authenticationResult]: (state) => {
    return state.result;
  },
  [storeGetters.authenticatedToken]: (state) => {
    return state.token;
  },
  [storeGetters.getUser]: (state) => {
    return state.user;
  },
  [storeGetters.getCurrentUser]:(state)=>{
    return state.currentUser
  }
};
export default { ...getters };
